/** Brochure — document knowledge definition. Pure data. */
export default {
  id: 'brochure',
  name: 'Brochure',
  description: 'A multi-panel company or product overview that tells a fuller story than a flyer.',
  purpose: 'Company & Product Presentation',
  recommendedSizes: [
    { name: 'A4 Tri-fold', width: 3508, height: 2480, unit: 'px' },
    { name: 'A4 Portrait', width: 2480, height: 3508, unit: 'px' },
  ],
  supportedOrientations: ['landscape', 'portrait'],
  supportsMultiplePages: true,
  supportsBleed: true,
  supportsImages: true,
  supportsIcons: true,
  supportsQR: true,
  supportsTables: true,
  supportsPricing: true,
  supportsCTA: true,
  supportsOffers: true,
  supportsTimeline: false,
  supportsGallery: true,
  typicalSections: ['Cover', 'About', 'Services', 'Gallery', 'Testimonials', 'Contact'],
};
